export default "__VITE_ASSET__Dp_hNpT8__"